import * as yup from 'yup';

export const estimatedReceptionFormSchema = (t: any): yup.AnyObjectSchema =>
  yup.object().shape({
    estimatedReceptions: yup.array().of(
      yup.object().shape({
        weight: yup.number().typeError(t('validation.weight.invalid')),
      }),
    ),
  });
